module.exports = __webpack_public_path__ + "img/sharp-example2.e29c5afb.jpg";